import PropTypes from "prop-types";
import React from "react";

const Testimonial = ({ testimonial, numSlides, index }) => {
  return (
    <div
      className="testimonial"
      role="group"
      aria-label={`slide ${index + 1} of ${numSlides}`}
    >
      <p className="text">{testimonial.testimony}</p>
      <p className="client-name">{testimonial.author}</p>
    </div>
  );
};

Testimonial.propTypes = {
  testimonial: PropTypes.object.isRequired,
};

export default Testimonial;



// WEBPACK FOOTER //
// ./src/components/homepage/testimonials/testimonial.js